/* eslint-disable max-lines */
import immutable from 'immutable';
import * as actions from './action';

const init = () => {
  const initValue = immutable.fromJS({
    machineVncSession: undefined
  });

  return initValue.set('machineVncSession', {
    data: null,
    id: null,
    isDoneCalling: false,
    expiresAt: null,
    isLoading: false,
    status: {
      data: null,
      code: null,
      statusResponse: [],
      isLoading: false
    },
    cachedSessionStatus: {
      data: null,
      isLoading: false,
      isDone: false,
      code: null
    },
    modal: {
      status: {
        visible: false
      },
      expiration: {
        visible: false
      },
      firmwareChecking: {
        visible: false
      },
      oneAlreadyRun: {
        visible: false
      }
    },
    vnc: {
      open: false,
      minimize: false,
      expand: false
    }
  });
};

export default function machineVncSessionReducer(state = init(), action) {
  switch (action.type) {
    case actions.REQUEST_MACHINE_VNC_SESSION_REQUEST:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        id: action.payload.machineId,
        isLoading: true
      }));

    case actions.REQUEST_MACHINE_VNC_SESSION_SUCCESS: {
      const {
        payload: { url, expiresAt }
      } = action;

      return state.update('machineVncSession', (machineVncSession) => {
        const earlier3MExpiresAtTimestamp = Date.parse(expiresAt) - 120000;
        const earlier3MExpiresAt = new Date(
          earlier3MExpiresAtTimestamp
        ).toISOString();

        if (machineVncSession.vnc.open && url && expiresAt) {
          return {
            ...machineVncSession,
            isLoading: false,
            isDoneCalling: true,
            data: url,
            expiresAt: earlier3MExpiresAt,
            status: {
              ...machineVncSession.status,
              isLoading: true
            }
          };
        }

        return {
          ...machineVncSession,
          isLoading: false,
          isDoneCalling: true
        };
      });
    }

    case actions.REQUEST_MACHINE_VNC_SESSION_FAIL:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        isLoading: false,
        isDoneCalling: true
      }));

    case actions.REQUEST_MACHINE_VNC_SESSION_RESET_STATE:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        data: null,
        id: null,
        expiresAt: null,
        isLoading: false,
        isDoneCalling: false
      }));

    case actions.GET_MACHINE_VNC_SESSION_STATUS_REQUEST:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        status: {
          ...machineVncSession.status,
          isLoading: true
        }
      }));

    case actions.SAVE_MACHINE_VNC_SESSION_STATUS_RESPONSE: {
      const {
        payload: { status, code }
      } = action;
      return state.update('machineVncSession', (machineVncSession) => {
        return {
          ...machineVncSession,
          status: {
            ...machineVncSession.status,
            data: null,
            code,
            statusResponse: [
              ...machineVncSession.status.statusResponse,
              status
            ],
            isLoading: true
          }
        };
      });
    }

    case actions.GET_MACHINE_VNC_SESSION_STATUS_SUCCESS:
      return state.update('machineVncSession', (machineVncSession) => {
        return {
          ...machineVncSession,
          isLoading: false,
          status: {
            ...machineVncSession.status,
            data: action.payload,
            isLoading: false
          }
        };
      });

    case actions.GET_MACHINE_VNC_SESSION_STATUS_FAIL:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        status: {
          ...machineVncSession.status,
          isLoading: false
        }
      }));

    case actions.GET_MACHINE_VNC_SESSION_STATUS_RESET_STATE:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        status: {
          data: null,
          code: null,
          isLoading: false,
          statusResponse: []
        }
      }));

    case actions.SHOW_MACHINE_VNC_SESSION_STATUS_MODAL:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        modal: {
          ...machineVncSession.modal,
          status: {
            visible: true
          }
        }
      }));

    case actions.HIDE_MACHINE_VNC_SESSION_STATUS_MODAL:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        modal: {
          ...machineVncSession.modal,
          status: {
            visible: false
          }
        }
      }));

    case actions.SHOW_MACHINE_VNC_SESSION_FIRMWARE_CHECKING_MODAL:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        modal: {
          ...machineVncSession.modal,
          firmwareChecking: {
            visible: true
          }
        }
      }));

    case actions.HIDE_MACHINE_VNC_SESSION_FIRMWARE_CHECKING_MODAL:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        modal: {
          ...machineVncSession.modal,
          firmwareChecking: {
            visible: false
          }
        }
      }));

    case actions.CHECK_MACHINE_VNC_CACHED_SESSION_REQUEST:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        cachedSessionStatus: {
          isLoading: true
        }
      }));

    case actions.CHECK_MACHINE_VNC_CACHED_SESSION_SUCCESS:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        cachedSessionStatus: {
          isLoading: false,
          isDone: true,
          data: action.payload.status,
          code: action.payload.code
        }
      }));

    case actions.CHECK_MACHINE_VNC_CACHED_SESSION_FAIL:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        cachedSessionStatus: {
          isLoading: false,
          isDone: true,
          data: null,
          code: null
        }
      }));

    case actions.CHECK_MACHINE_VNC_CACHED_SESSION_RESET_STATE:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        cachedSessionStatus: {
          data: null,
          isDone: false,
          code: null,
          isLoading: false
        }
      }));

    case actions.SHOW_MACHINE_VNC_SESSION_EXPIRATION_MODAL:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        modal: {
          ...machineVncSession.modal,
          expiration: {
            visible: true
          }
        }
      }));

    case actions.HIDE_MACHINE_VNC_SESSION_EXPIRATION_MODAL:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        modal: {
          ...machineVncSession.modal,
          expiration: {
            visible: false
          }
        }
      }));

    case actions.OPEN:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        vnc: {
          ...machineVncSession.vnc,
          open: true,
          expand: true
        }
      }));

    case actions.CLOSE:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        vnc: {
          ...machineVncSession.vnc,
          open: false,
          expand: false,
          minimize: false
        }
      }));

    case actions.EXPAND:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        vnc: {
          ...machineVncSession.vnc,
          expand: true,
          minimize: false
        }
      }));

    case actions.UNEXPAND:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        vnc: {
          ...machineVncSession.vnc,
          expand: false,
          minimize: false
        }
      }));

    case actions.MINIMIZE:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        vnc: {
          ...machineVncSession.vnc,
          expand: false,
          minimize: true
        }
      }));

    case actions.UNMINIMIZE:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        vnc: {
          ...machineVncSession.vnc,
          minimize: false,
          expand: false
        }
      }));

    case actions.RESET_VNC_UI:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        vnc: {
          open: false,
          minimize: false,
          expand: false
        }
      }));

    case actions.CACHED_OPEN:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        vnc: {
          ...machineVncSession.vnc,
          open: true,
          expand: false,
          minimize: false
        }
      }));

    case actions.SHOW_MACHINE_VNC_SESSION_CHECK_ONE_ALREADY_RUN_MODAL:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        modal: {
          ...machineVncSession.modal,
          oneAlreadyRun: {
            visible: true
          }
        }
      }));

    case actions.HIDE_MACHINE_VNC_SESSION_CHECK_ONE_ALREADY_RUN_MODAL:
      return state.update('machineVncSession', (machineVncSession) => ({
        ...machineVncSession,
        modal: {
          ...machineVncSession.modal,
          oneAlreadyRun: {
            visible: false
          }
        }
      }));

    default:
      return state;
  }
}
